import { render, staticRenderFns } from "./BannersPage.vue?vue&type=template&id=9feb39be&scoped=true"
import script from "./BannersPage.vue?vue&type=script&lang=js"
export * from "./BannersPage.vue?vue&type=script&lang=js"
import style0 from "./BannersPage.vue?vue&type=style&index=0&id=9feb39be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9feb39be",
  null
  
)

export default component.exports